import { useMutation } from "react-query";
import { postDataWithDotNet } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { appInsights } from "../../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../../helpers/errorHandler";
import { TUnlockApprovalPayload } from "./useApproveAdminUnlock";

const rejectAdminUnlock = async (
  payload: TUnlockApprovalPayload,
): Promise<void> => {
  await postDataWithDotNet(ajaxEndpoints.REJECT_ADMIN_UNLOCK, payload);
};

export function useRejectAdminUnlock() {
  const [mutate, result] = useMutation(
    (payload: TUnlockApprovalPayload) => rejectAdminUnlock(payload),
    {
      onSuccess: () => {
        message.success("User unlock rejected successfully.");
      },
      onError: (error: any) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useRejectAdminUnlock.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
